/**
 * GTM `ecomm_pagetype` data-layer values, mirrored from the SFRA
 * `int_gtm_sfra` cartridge's `gtmPageTypesMapping` Business Manager custom
 * preference (identical across FSASTORE / HSASTORE / WDH).
 *
 * `ecomm_pagetype` is the value Google Ads dynamic-remarketing tags read off
 * the data layer, so it must match SFRA exactly to keep remarketing audiences
 * consistent as pages move from SFRA to MRT.
 *
 * Source of truth: `sfcc-website` -> `gtmPageTypesMapping`. Only `home` is
 * wired up on MRT today — the homepage was migrated SFRA -> MRT in SFCC-10847
 * and lost its page type because MRT had no equivalent of the SFRA cartridge.
 * The remaining entries are kept here for parity/reference as more pages move
 * over (the `productListing` subtypes mirror SFRA's nested `product_listing`).
 */
export const ECOMM_PAGE_TYPES = {
    home: 'HomePage',
    cart: 'Cart Page',
    checkout: 'Checkout Page',
    content: 'Content Page',
    calculator: 'FSA Calculator',
    learn: 'Learning Center Page',
    pdp: 'Product Display Page',
    clp: 'Custom Landing Page',
    search: 'Search Results Page',
    payment: 'Payment Page',
    savings: 'Savings Center Page',
    purchase: 'Purchase Page',
    account: 'Account Page',
    favorites: 'Favorites Page',
    other: 'Other Page',
    notfound: 'Page Not Found',
    productListing: {
        default: 'Product Listing Page',
        brand: 'Brand Page',
        eligibility: 'Eligibility List Page'
    }
}
